import { render, staticRenderFns } from "./ChapterSelect.vue?vue&type=template&id=596b67e4&scoped=true"
import script from "./ChapterSelect.vue?vue&type=script&lang=js"
export * from "./ChapterSelect.vue?vue&type=script&lang=js"
import style0 from "./ChapterSelect.vue?vue&type=style&index=0&id=596b67e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b67e4",
  null
  
)

export default component.exports